'use client';

import dynamic from 'next/dynamic';

/**
 * `@carvana/ds-select` (inside `ShopPaymentForm`) generates aria ids via
 * `crypto.randomUUID()` instead of `useId()`, causing a real hydration
 * mismatch once this route server-renders it with real data. `ssr: false`
 * sidesteps it; the real fix belongs in `ds-select`. Split into its own
 * module because `dynamic(..., { ssr: false })` requires a Client Component.
 */
export default dynamic(() => import('./ShopPaymentForm'), { ssr: false });
